import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { titleCase, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../common/app_constant";
// import Blog from "../../../../component/blog";
import _ from 'lodash';
import AddAppointments from "./add";
import { actionGetAppointments, resetGetAppointmentsResponse } from "./store";
import Loader from "../../../../component/page_loader";
import InfromationCard from "../../../../component/information_card";
import { ALL_CONTACT_PERSON } from "../../../../common/constant";


const Appointments = () => {


    const dispatch = useDispatch()
    const navigation = useNavigate()

    const { getAppointments } = useSelector((state) => ({
        ...state.appointmentsStore
    }))

    const [isDispaly, setIsDisplay] = useState(false)
    const [appointments, setAppointments] = useState([])
    const [clicked, setClicked] = useState("0");
    const contentEl = useRef();
    const [isLoader, setIsLoader] = useState(true)

    const handleToggle = (index) => {
        if (clicked === index) {
            return setClicked("0");
        }
        setClicked(index);
    };

    useEffect(() => {
        dispatch(actionGetAppointments())
    }, [])

    useEffect(() => {
        if (getAppointments !== null) {
            dispatch(resetGetAppointmentsResponse())
            if (getAppointments.result === true) {
                setAppointments(getAppointments.response)
                setIsLoader(false)
            } else {
                setIsLoader(false)
                switch (getAppointments.status) {
                    case 400:
                        toast.error(getAppointments.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [getAppointments])

    const renderDate = (date = null, value) => {
        var appointmentDate = ''
        if (date != null) {
            var appointmentDateSplit = date
            var month = appointmentDateSplit.split('-')
            if (value === 'month') {
                appointmentDate = month[0]
            }
            if (value === 'date') {
                appointmentDate = month[1]
            }
            if (value === 'year') {
                appointmentDate = month[2]
            }
        }

        return appointmentDate
    }


    const renderTime = (date, value = null) => {

        var startAndEndTime = ''
        if (date != null) {
            var appointmentDateSplit = date
            var time = appointmentDateSplit.split(' ')

            if (value === 'start') {
                startAndEndTime = moment(time[1], 'hh:mm:ss').format("hh:mm A")
            }
            if (value === 'end') {
                startAndEndTime = moment(time[1], 'hh:mm:ss').format("hh:mm A")
            }
        }

        return startAndEndTime
    }

    const renderAttenders = (attenders = null) => {
        var strAttender = "";
        if (attenders != null && attenders.length > 0) {
            attenders.forEach((item, index) => {
                strAttender = String(strAttender).concat(item.full_name);
                strAttender = String(strAttender).concat(",");
            });
        }

        return String(strAttender).substring(0, strAttender.length - 1);
    };

    const renderGroupName = (groupName) => {
        var strGroupName = ''
        if (groupName != null) {
            strGroupName = titleCase(groupName)
        }
        return strGroupName
    }

    const renderCompantyName = (companyName) => {
        var strCompanyName = ''
        if (strCompanyName != null) {
            strCompanyName = titleCase(companyName)
        }
        return strCompanyName
    }

    return (
        <>
            <div className="row py-5">
                <div className="col-12">
                    <nav
                        aria-label="breadcrumb"
                    >
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a onClick={() => {
                                // navigation('/dashboard')
                            }}>Dashboard</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Appointments</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 col-md-8">
                    {
                        isLoader === true ?
                            <Loader />
                            :
                            <div>
                                <div className="mt-4 d-flex justify-content-between tab-menu">
                                    <h6>
                                        Appointments ({appointments.length})
                                    </h6>
                                </div>

                                <div className="row">
                                    <div className="mt-4">
                                        {
                                            appointments != null && appointments.length > 0 ?
                                                appointments.map((item, index) => {
                                                    return (
                                                        <div className="col-md-12 mb-2">
                                                            <div className="card">
                                                                <div className="card-body pb-0 cursor-pointer">
                                                                    <div className="row mb-2" onClick={() => {
                                                                        handleToggle(index)
                                                                    }}>
                                                                        <div className="col-12 col-md-2 text-center my-auto position-relative ">
                                                                            <div className="rounded card shadow  calendar border-top">
                                                                                <div className="card-header bg-light pt-3">
                                                                                    <span className=" bg-light text-primary rounded-pill fw-600">
                                                                                        {renderDate(moment(item.start_date_time).format("MMMM-DD-YYYY"), 'month')}
                                                                                    </span>
                                                                                    <h5 className="mt-1 mb-1">{renderDate(moment(item.start_date_time).format("MMMM-DD-YYYY"), 'year')}</h5>
                                                                                </div>
                                                                                <h1 className="fw-bold mt-2 text-primary">{renderDate(moment(item.start_date_time).format("MMMM-DD-YYYY"), 'date')}</h1>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12 col-md-8 mt-3 mt-md-0">
                                                                            <div className="row">
                                                                                <div className="col-12 col-md-6">
                                                                                    <p className="mb-0 fw-600">Time</p>
                                                                                    <p className="mb-0 fw-bold">{renderTime(item.start_date_time, 'start')} - {renderTime(item.end_date_time, 'end')}</p>
                                                                                </div>
                                                                                <div className="col-12 col-md-6 mt-2 mt-md-0 mb-2">
                                                                                    <p className="mb-0">Location </p>
                                                                                    <p className="mb-0 fw-bold">
                                                                                        {item.location}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="col-12 mt-2">
                                                                                    <p className="mb-0 text-primary">Agenda : </p>
                                                                                    <p className="mb-0 fw-bold">
                                                                                        {item.agenda}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="col-12 col-md-6 mt-2  mb-2">
                                                                                    <p className="mb-0">RM Name </p>
                                                                                    <p className="mb-0 fw-bold">{item.creator_name}</p>
                                                                                </div>
                                                                                <div className="col-12 col-md-6 mt-2  mb-2">
                                                                                    <p className="mb-0">Accompanied By </p>
                                                                                    <p className="mb-0 fw-bold">{renderAttenders(item?.attenders)}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-12 col-md-2">
                                                                            <p className="mb-0 fw-600">Status</p>
                                                                            <span className="badge bg-success  rounded-pill mb-2">
                                                                                {_.capitalize(item.status)}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div ref={contentEl}
                                                                        hidden={clicked === index ? false : true}>
                                                                        <div className="row border-top py-2 mt-1 bg-light">
                                                                            <div className="col-12 mt-2">
                                                                                <p className="mb-2 text-primary">Minutes of Meeting : </p>
                                                                                <p className="mb-0 fw-bold">
                                                                                    {item.minutes_of_meeting}
                                                                                </p>
                                                                            </div>
                                                                            <div className="col-12 col-md-4 mt-3">
                                                                                <p className="mb-0">Group Name :</p>
                                                                                <p className="mb-0 fw-bold">{renderGroupName((item.group_name).toLowerCase())}</p>
                                                                            </div>
                                                                            <div className="col-6 col-md-4 mt-3">
                                                                                <p className="mb-0">Company Name :</p>
                                                                                <p className="mb-0 fw-bold">{renderCompantyName((item.name).toLowerCase())}</p>
                                                                            </div>
                                                                            <div className="col-6 col-md-4 mt-3">
                                                                                <p className="mb-0">Contact Person </p>
                                                                                <p className="mb-0 fw-bold">{item.contact_name}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className="d-flex justify-content-center align-items-center mt-5">
                                                    <h5>No Appointments To Display</h5>
                                                </div>}
                                    </div>
                                </div>
                            </div>
                    }

                </div>
                <div className="col-12 col-md-4">
                    <InfromationCard isMarginTop={false} />
                    {/* <Blog /> */}
                   

                </div>
            </div>

            <AddAppointments
                isAppointments={isDispaly}
                isClose={() => {
                    setIsDisplay(false)
                }}
            />
        </>

    )

}

export default Appointments;